import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

class LikesService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_URL}/likes`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add auth token to requests
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  // Create a like
  async createLike(userId, likeableId, likeableType) {
    try {
      const response = await this.api.post('', {
        userId,
        likeableId,
        likeableType,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Delete a like
  async deleteLike(userId, likeableId, likeableType) {
    try {
      const response = await this.api.delete(`/${userId}/${likeableId}/${likeableType}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get likes for an entity (club or player)
  async getEntityLikes(likeableId, likeableType, page = 1, limit = 10) {
    try {
      const response = await this.api.get(`/entity/${likeableId}/${likeableType}`, {
        params: { page, limit },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Check if user has liked an entity
  async checkUserLike(userId, likeableId, likeableType) {
    try {
      const response = await this.api.get(`/check/${userId}/${likeableId}/${likeableType}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get like statistics for an entity
  async getLikeStats(likeableId, likeableType) {
    try {
      const response = await this.api.get(`/stats/${likeableId}/${likeableType}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Check user's like limit
  async getLikeLimit(userId) {
    try {
      const response = await this.api.get(`/limit/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get user's likes
  async getUserLikes(userId, page = 1, limit = 10, type = null) {
    try {
      const params = { page, limit };
      if (type) params.type = type;
      
      const response = await this.api.get(`/user/${userId}`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}

export default new LikesService(); 